import { useEffect, useState } from 'react';
import { Header, HeaderLabel, Page, Content, TabbedLayout } from '@backstage/core-components';
import { identityApiRef, useApi } from '@backstage/core-plugin-api';
import { RegistryTab } from '../lh-registry/RegistryTab';
import { RegistryNewForm } from '../lh-registry/RegistryNewForm';
import { RegistryNewConnection } from '../lh-registry/RegistryNewConnection';
import { ManifestReviewPage } from '../lh-registry/ManifestReviewPage';
import { MenuRoute } from '../portal-access/MenuRoute';
import { useRegistryAccess } from '../portal-access/useRegistryAccess';

export const RegistryPage = () => {
  const { canWrite: isWriter, loading } = useRegistryAccess();
  const identityApi = useApi(identityApiRef);
  const [email, setEmail] = useState<string>();
  useEffect(() => {
    identityApi.getProfileInfo().then(p => setEmail(p.email)).catch(() => undefined);
  }, [identityApi]);

  return (
    <Page themeId="tool">
      <Header title="수집 현황 레지스트리" type="Data Platform › ygy_meta.dp_table_list 대체">
        {/* 권한 표시는 UI 힌트다 — 실제 쓰기 차단은 서버 403 */}
        {!loading && (isWriter ? <HeaderLabel label="쓰기 권한" value={email ?? '—'} /> : <HeaderLabel label="읽기 전용" value="쓰기 권한 없음" />)}
      </Header>
      <TabbedLayout>
        <TabbedLayout.Route path="/" title="목록">
          <Content>
            <RegistryTab />
          </Content>
        </TabbedLayout.Route>
        {/* 읽기 전용 사용자에게도 탭은 보이고, 화면 안에서 입력이 잠긴다 */}
        {/* 경로는 링크 호환을 위해 유지. 새 domain 은 여기서 함께 만들고 OM service ↔ conn_id 매핑도 여기서 관리한다 */}
        <TabbedLayout.Route path="/new-connection" title="connection">
          <Content>
            <RegistryNewConnection />
          </Content>
        </TabbedLayout.Route>
        <TabbedLayout.Route path="/new" title="신규 테이블">
          <Content>
            <RegistryNewForm />
          </Content>
        </TabbedLayout.Route>
        {/* registry.writer 이상만 탭이 보인다. 직접 URL 로 와도 MenuRoute 가 돌려보낸다 (실제 차단은 서버 403) */}
        {isWriter ? (
          <TabbedLayout.Route path="/manifest-review" title="Manifest 검토">
            <Content>
              <MenuRoute menu="registry.writer">
                <ManifestReviewPage />
              </MenuRoute>
            </Content>
          </TabbedLayout.Route>
        ) : (
          <></>
        )}
      </TabbedLayout>
    </Page>
  );
};
